import { IconButton, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import PreviewIcon from "@mui/icons-material/Preview";

import { TableLayout } from "../../layout/TableLayout";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { selectEvent } from "../../../store/event/eventSlice";
import { EditEvent } from "./EditEvent";
import { deleteEvent } from "../../helpers/event";
import { useNavigate } from "react-router-dom";

export const EventTable = ({ rows, setReloadData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("global");
  const [openEdit, setOpenEdit] = useState(false);
  const dispatch = useDispatch();

  const onEditClick = (e) => {
    dispatch(selectEvent(e.row));
    setOpenEdit(true);
  };
  const onDeleteClick = async (e) => {
    await deleteEvent(
      e,
      t("delete.successMsg"),
      t("delete.errorMsg"),
      t("delete.cancelButton"),
      t("delete.confirmButton"),
      t("delete.deleteConfirm")
    );
    setReloadData((prevState) => !prevState);
  };

  const onViewClick = async (e) => {
    navigate(`/viewRegistered?event=${e.row.id}&name=${e.row.name}`);
  };

  const columns = [
    {
      field: "name",
      headerName: t("addevent.name"),
      minWidth: 220,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "eventDate",
      headerName: t("addevent.eventDate"),
      minWidth: 140,
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "url",
      headerName: t("addevent.urlRegistration"),
      minWidth: 130,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <a href={params.row.url} target="_blank" rel="noreferrer">
              {t("link.link")}
            </a>
          </Stack>
        );
      },
    },
    {
      field: "action",
      headerName: t("partnerlist.columnActions"),
      maxWidth: 130,
      align: "center",
      headerAlign: "center",
      flex: 0,
      sortable: false,
      renderCell: (params) => {
        return (
          <Stack direction="row" gap={0}>
            <IconButton color="secondary" onClick={() => onViewClick(params)}>
              <PreviewIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onEditClick(params)}>
              <EditRoundedIcon />
            </IconButton>

            <IconButton color="secondary" onClick={() => onDeleteClick(params)}>
              <DeleteOutlineRoundedIcon />
            </IconButton>
          </Stack>
        );
      },
    },
  ];

  return (
    <>
      <TableLayout rows={rows} columns={columns} title="events" />
      {openEdit && (
        <EditEvent setHidden={setOpenEdit} setReloadData={setReloadData} />
      )}
    </>
  );
};
